import { Network } from '@hyperjump-defi/sdk'
import tokens from './tokens'
import { FarmConfig } from './types'

/**
 * These LPs are just used to help with price calculation for MasterChef LPs (farms.ts).
 * This list is added to the MasterChefLps and passed to fetchFarm. The calls to get contract information about the token/quoteToken in the LP are still made.
 * The absense of a PID means the masterchef contract calls are skipped for this farm.
 * Prices are then fetched for all farms (masterchef + priceHelperLps).
 * Before storing to redux, farms without a PID are filtered out.
 */
const priceHelperLps: Record<Network, FarmConfig[]> = {
  [Network.FANTOM]: [],
  [Network.BSC]: [],
  [Network.METIS]: [],
  [Network.BSC_TESTNET]: [],
  [Network.METIS_TESTNET]: [],
}

export default priceHelperLps
